import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/DashboardStyles.css";

export const StatCard = ({
  title,
  value,
  icon,
  color,
  additionalInfo,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const bgColor = `${color}1A`;

  const cardStyle = {
    position: "relative",
    padding: "1.5rem",
    borderRadius: "0.75rem",
    background: bgColor,
    transition: "all 0.3s ease",
    boxShadow: isHovered
      ? "0 10px 25px rgba(0,0,0,0.1)"
      : "0 4px 12px rgba(0,0,0,0.05)",
    transform: isHovered ? "translateY(-4px)" : "translateY(0)",
    overflow: "hidden",
    cursor: onClick ? "pointer" : "default",
  };

  const glowStyle = {
    position: "absolute",
    top: "-2.5rem",
    right: "-2.5rem",
    width: "8rem",
    height: "8rem",
    borderRadius: "50%",
    background: color,
    opacity: "0.15",
    filter: "blur(1.5rem)",
    transition: "all 0.5s ease",
    transform: isHovered ? "scale(1.5)" : "scale(1)",
  };

  const contentContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    position: "relative",
    zIndex: "1",
  };

  const textContainerStyle = {
    flexGrow: 1,
  };

  const titleStyle = {
    fontSize: "0.875rem",
    color: "#64748b",
    fontWeight: "500",
    marginBottom: "0.5rem",
  };

  const valueStyle = {
    fontSize: "1.875rem",
    fontWeight: "700",
    color: color,
    marginBottom: "0.75rem",
    transition: "all 0.3s ease",
  };

  const additionalInfoStyle = {
    marginTop: "1rem",
    fontSize: "0.75rem",
    fontWeight: "500",
    color: color,
    display: "flex",
    gap: "1rem",
    flexWrap: "wrap",
  };

  const iconContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3rem",
    height: "3rem",
    borderRadius: "0.75rem",
    transition: "all 0.3s ease",
    background: isHovered ? color : bgColor,
    color: isHovered ? "#ffffff" : color,
  };

  const indicatorLineStyle = {
    position: "absolute",
    bottom: "0",
    left: "0",
    height: "0.25rem",
    background: color,
    transition: "all 0.3s ease",
    width: isHovered ? "100%" : "30%",
  };

  const statusDotStyle = {
    display: "inline-block",
    width: "0.5rem",
    height: "0.5rem",
    borderRadius: "50%",
    marginRight: "0.5rem",
  };

  return (
    <div
      style={cardStyle}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={glowStyle}></div>

      <div style={contentContainerStyle}>
        <div style={textContainerStyle}>
          <div style={titleStyle}>{title}</div>
          <div style={valueStyle}>{value}</div>

          {additionalInfo && (
            <div style={additionalInfoStyle}>{additionalInfo}</div>
          )}
        </div>
      </div>

      <div style={indicatorLineStyle}></div>
    </div>
  );
};

export const ContentCard = ({
  title,
  additionalInfo,
  icon,
  action,
  children,
  isWide,
  footer,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Card styles
  const styles = {
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow: isHovered
        ? "0 10px 25px rgba(0, 0, 0, 0.08)"
        : "0 4px 12px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s ease",
      border: "1px solid rgba(226, 232, 240, 0.8)",
      width: isWide ? "100%" : "auto",
      overflow: "hidden",
      marginBottom: "24px",
    },
    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "18px 24px",
      borderBottom: "1px solid rgba(226, 232, 240, 0.7)",
      backgroundColor: isHovered ? "#f8fafc" : "#ffffff",
      transition: "background-color 0.3s ease",
    },
    cardTitle: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      color: "#1e293b",
      fontWeight: "600",
      fontSize: "1rem",
    },
    cardTitleIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      height: "32px",
      borderRadius: "8px",
      backgroundColor: "#f1f5f9",
      color: "#3b82f6",
      transition: "all 0.3s ease",
      transform: isHovered ? "scale(1.05)" : "scale(1)",
    },
    cardContent: {
      padding: "24px",
    },
    cardFooter: {
      padding: "16px 24px",
      borderTop: "1px solid rgba(226, 232, 240, 0.7)",
      backgroundColor: "#f8fafc",
    },
    // Form control styles for the example
    formControl: {
      display: "block",
      width: "100%",
      padding: "12px 16px",
      fontSize: "0.95rem",
      lineHeight: "1.5",
      color: "#334155",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      transition: "border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    },
    formSelect: {
      display: "block",
      width: "100%",
      padding: "12px 16px",
      fontSize: "0.95rem",
      lineHeight: "1.5",
      color: "#334155",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      transition: "border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 16px center",
      backgroundSize: "16px",
    },
    row: {
      display: "flex",
      flexWrap: "wrap",
      marginLeft: "-12px",
      marginRight: "-12px",
    },
    column: {
      flex: "0 0 50%",
      maxWidth: "50%",
      paddingLeft: "12px",
      paddingRight: "12px",
      marginBottom: "16px",
    },
    mobileColumn: {
      flex: "0 0 100%",
      maxWidth: "100%",
      paddingLeft: "12px",
      paddingRight: "12px",
      marginBottom: "16px",
    },
  };

  // Media query handling
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  const isMobile = windowWidth < 768;

  return (
    <div
      style={styles.card}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={styles.cardHeader}>
        <div style={styles.cardTitle}>
          <div style={styles.cardTitleIcon}>{icon}</div>
          {title}
        </div>
        {action}
      </div>
      <div style={styles.cardContent}>{children}</div>
      {footer && <div style={styles.cardFooter}>{footer}</div>}
    </div>
  );
};

export const ActionLink = ({ to, text, icon, onClick }) => {
  if (onClick) {
    return (
      <button className="card-action" onClick={onClick} type="button">
        {icon}
        <span>{text}</span>
      </button>
    );
  }

  return (
    <Link to={to} className="card-action">
      {icon}
      <span>{text}</span>
    </Link>
  );
};

export const DashboardHeader = ({ title }) => (
  <h2 className="mb-4 greeting">
    {title}
    <div className="greeting-underline"></div>
  </h2>
);



export const StatusBadge = ({ status, variant }) => {
  let badgeClass = variant || "";

  // Add null check to prevent accessing toLowerCase() on undefined or null
  if (!variant && status) {
    switch (status.toLowerCase()) {
      case "approved":
      case "resolved":
      case "active":
        badgeClass = "success";
        break;
      case "pending":
      case "in progress":
      case "forwarded to dgar":
      case "pending approval":
        badgeClass = "warning";
        break;
      case "rejected":
      case "inactive":
        badgeClass = "danger";
        break;
      case "closed":
        badgeClass = "secondary";
        break;
      default:
        badgeClass = "primary";
    }
  }

  return (
    <span className={`status-badge status-${badgeClass}`}>
      {status || "Unknown"}
    </span>
  );
};

export const Icons = {
  Users: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  ),
  Centers: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7"></rect>
      <rect x="14" y="3" width="7" height="7"></rect>
      <rect x="14" y="14" width="7" height="7"></rect>
      <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
  ),
  Grievances: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  ),
  Grants: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="16"></line>
      <line x1="8" y1="12" x2="16" y2="12"></line>
    </svg>
  ),
  Notifications: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
  ),
  Activities: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3v18"></path>
      <path d="M5 13h14"></path>
      <path d="M5 7h14"></path>
      <path d="M5 19h14"></path>
    </svg>
  ),
  Calculator: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
      <line x1="8" y1="6" x2="16" y2="6"></line>
      <line x1="8" y1="10" x2="16" y2="10"></line>
      <line x1="8" y1="14" x2="16" y2="14"></line>
      <line x1="8" y1="18" x2="16" y2="18"></line>
    </svg>
  ),
  Add: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Filter: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>
  ),
  Delete: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18"></path>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  ),
  Graph: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="20" x2="18" y2="10"></line>
      <line x1="12" y1="20" x2="12" y2="4"></line>
      <line x1="6" y1="20" x2="6" y2="14"></line>
    </svg>
  ),
  Event: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  ),
  Document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <line x1="10" y1="9" x2="8" y2="9"></line>
    </svg>
  ),
  IDCard: (
    <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
  <circle cx="8" cy="11" r="2"></circle>
  <path d="M14 11h6"></path>
  <path d="M14 15h4"></path>
</svg>
  ),

};
